import { render, staticRenderFns } from "./Selectapi.vue?vue&type=template&id=4541b800&"
import script from "./Selectapi.vue?vue&type=script&lang=js&"
export * from "./Selectapi.vue?vue&type=script&lang=js&"
import style0 from "./Selectapi.vue?vue&type=style&index=0&id=4541b800&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports